module.exports = __webpack_public_path__ + "images/centerpinb8f4d2fbab297600256bede4194f6b95.png";